import { ReactNode } from 'react'

import { Menu } from './Menu/Menu'

import cl from './InfoPageLayout.module.scss'

interface InfoPageLayoutProps {
	children: ReactNode
}

export const InfoPageLayout = (props: InfoPageLayoutProps) => {
	const { children } = props
	return (
		<div className={cl.root}>
			<div className={cl.menu}>
				<Menu />
			</div>
			<div>{children}</div>
		</div>
	)
}
